import Intercom from "src/composables/Intercom";

export default ({ router }) => {
    const { call_intercom } = Intercom();
    router.afterEach((to, from) => {
        document.title = to.meta.title;
        call_intercom({ command: 'update' })
    })
}
